export class Address {
    // creation_datetime: date;
    public id: number;
    public display_name: string; // required with minimum 5 chracters
    public address1: string;
    public address2: string;
    public city: string;
    public county: string;
    public postcode: string;
    public country: string;
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_models/address.ts